import { Wrapper } from './Wrapper';
import { Input } from './Input';
import { Menu } from './Menu';
import { MenuItem } from './MenuItem';

import type {
  Components,
} from '../types';

export const components: Components = {
  Wrapper,
  Input,
  Menu,
  MenuItem,
};
